import { TablePagination } from '@material-ui/core';
import { FieldProps } from 'formik';
import React, { useMemo } from 'react';
import { ILPUBudgetValueFormValue } from '../../../../@types/model/transformer/budget';
import { ITransformerCompany } from '../../../../@types/model/transformer/transformer';

interface IBudgetTablePaginationFieldProps extends FieldProps {
    hideDetail ?: boolean;

    company : ITransformerCompany | null;
    area : string | null;
    transformer : string | null;
    accountNumber : string | null;
    period : number | null;

    rowsPerPageOptions : Array<number>;
    currentPage : number;
    rowsPerPage : number;

    onPageChange : (event : React.MouseEvent<HTMLButtonElement> | null, page : number) => void;
    onRowsPerPageChange : (event ?: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const BudgetTablePaginationField = (props: IBudgetTablePaginationFieldProps): React.ReactElement => {

    const valuesFromForm = useMemo<Array<ILPUBudgetValueFormValue>>(() => {
        if (props.form && props.form.values && Array.isArray(props.form.values.values)) {
            return props.form.values.values as Array<ILPUBudgetValueFormValue>;
        }
        return [];
    }, [props.form?.values?.values]);

    const count = useMemo<number>(() => {
        return valuesFromForm
            .filter(x => !props.company || (x.transformer.Company?.id === props.company.id))
            .filter(x => !props.area || (x.transformer.Division === props.area))
            .filter(x => !props.transformer || (x.transformer.EPNumber === props.transformer))
            .filter(x => !props.accountNumber || (x.transformer.AccountNumber === props.accountNumber))
            .filter(x => !props.period || (x.month === props.period))
            .length;
    }, [
        valuesFromForm,
        props.company,
        props.area,
        props.transformer,
        props.accountNumber,
        props.period,
    ]);

    return (
        <TablePagination
            component='div'
            rowsPerPageOptions={props.rowsPerPageOptions}
            count={count}
            rowsPerPage={props.rowsPerPage}
            page={props.currentPage}
            onPageChange={props.onPageChange}
            onRowsPerPageChange={props.onRowsPerPageChange}
        />
    );
};

export default BudgetTablePaginationField;
